module.exports = __webpack_public_path__ + "img/pdf_ico.2e9b6520.png";